// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../.yarn/__virtual__/css-loader-virtual-85d6bada94/0/cache/css-loader-npm-7.1.1-25b990b98a-435a21f195.zip/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aligner-label {
  font-size: 0.875rem;
  font-weight: 500;
  display: block;
}

.aligner-toggler {
  padding: 0;
}

.aligner--align-left {
  text-align: left;
}

.aligner--align-center {
  text-align: center;
}

.aligner--align-right {
  text-align: right;
}

.aligner--align-justify {
  text-align: justify;
}`, "",{"version":3,"sources":["webpack://./assets/js/components/editorjs/components/tune-alignment/index.css"],"names":[],"mappings":"AAIA;EACC,mBAAA;EACA,gBAAA;EACA,cAAA;AAHD;;AAMA;EACC,UAAA;AAHD;;AAMA;EACC,gBAAA;AAHD;;AAMA;EACC,kBAAA;AAHD;;AAMA;EACC,iBAAA;AAHD;;AAMA;EACC,mBAAA;AAHD","sourcesContent":[".aligner-container {\r\n\t\r\n}\r\n\r\n.aligner-label {\r\n\tfont-size: 0.875rem;\r\n\tfont-weight: 500;\r\n\tdisplay:block;\r\n}\r\n\r\n.aligner-toggler {\r\n\tpadding:0;\r\n}\r\n\r\n.aligner--align-left {\r\n\ttext-align: left;\r\n}\r\n\r\n.aligner--align-center {\r\n\ttext-align: center;\r\n}\r\n\r\n.aligner--align-right {\r\n\ttext-align: right;\r\n}\r\n\r\n.aligner--align-justify {\r\n\ttext-align: justify;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
